import React, { useEffect, useMemo, useState } from "react";
import "./newSidebar.scss";
import { useLocation, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { Button } from "antd";
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { newSidebarRoutes } from "../Sidebar/NavLink";
import { useDispatch, useSelector } from "react-redux";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import bt_logo from "../../assets/Images/bitcomm_logo_short.png";
import tams_logo from "../../assets/Images/tams_logo.png";
import {
  resetSidebar,
  selectedExtentedSidebar,
  selectSidebarKey,
  updateExtentedSidebar,
  updateSelectedSidebarKey,
} from "./sidebarSlice";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { getLocalStorage, getParsedLocalStorage } from "../../Utils/storage-utils";
import { decryptFromURL } from "../Login/encryption-utils";
import useLogout from "../Login/useLogout";
import toast from "react-hot-toast";
import { redirectToFams } from "./redirectUtils";
import { getRoutObjByUrl } from "./sidebarUtils";
import packageJson from "../../../package.json";

const routes = [...new Array(6)].map((a, index) => {
  return { key: `Item${index}` };
});

const _routes = {};

const CollapseList = ({ routeObj, onListitemClick }) => {
  const [open, setOpen] = useState(false);
  const extentedSidebar = useSelector(selectedExtentedSidebar);
  const selectedKey = useSelector(selectSidebarKey);
  const { key, childs = [], label } = routeObj;
    

  return (
    <>
      <Tooltip title={label} enterDelay={400} leaveDelay={100} disableHoverListener={extentedSidebar} placement="right">
        <div className="list-item-content"
          onClick={() => setOpen((prev) => !prev)}
        >
          {routeObj.icon ? routeObj.icon : extentedSidebar ? "" : label.slice(0, 3) + ".."}
          {Boolean(extentedSidebar) && label}
          <IconButton
            className="sidebar-lititem-action-icon"
          >
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </div>
      </Tooltip>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <ul className="collapsable-list">
          {childs.map((childObj) => {
            const childTabKey = [key, childObj.key].join("*");
       
            return (
              <li
                className={`${
                  selectedKey === childTabKey
                    ? "sidebar-route-list-item-selected"
                    : "sidebar-route-list-item-unselected"
                } sidebar-route-list-item`}
                onClick={(event) => {
                  onListitemClick(childObj, childTabKey);
                }}
              >
                {["route_comp", "rediect_url"].includes(childObj.type) && (
                  <Tooltip
                    title={childObj.label}
                    enterDelay={400}
                    leaveDelay={100}
                    disableHoverListener={extentedSidebar}
                    placement="right"
                  >
                    <div className="list-item-content list-item-content-second-child">
                      {childObj.icon ? childObj.icon : extentedSidebar ? "" : childObj.label.slice(0, 3) + ".."}
                      {/* {childObj.icon ?? ""} */}
                      {Boolean(extentedSidebar) && childObj.label}

                      {childObj.type === "rediect_url" && extentedSidebar && (
                        <IconButton size="sm" className="sidebar-lititem-action-icon">
                          <OpenInNewIcon />
                        </IconButton>
                      )}
                    </div>
                  </Tooltip>
                )}
              </li>
            );
          })}
        </ul>
      </Collapse>
    </>
  );
};

//type : collapse_list,route_comp,rediect_url
const SidebarListItem = ({ routeObj, onListitemClick }) => {
  const extentedSidebar = useSelector(selectedExtentedSidebar);
  const selectedKey = useSelector(selectSidebarKey);

  const item_type = routeObj.type;
  const { key, label } = routeObj;

  return (
    <li
      key={key}
      className={`${
        key === selectedKey.split("*")[0] ? "sidebar-route-list-item-selected" : "sidebar-route-list-item-unselected"
      } ${"sidebar-route-list-item" + item_type} sidebar-route-list-item`}
      onClick={(event) => {
        onListitemClick(routeObj, key);
      }}
    >
      {item_type === "collapse_list" && (
        <CollapseList routeObj={routeObj} selectedKey={selectedKey} onListitemClick={onListitemClick} />
      )}
      {["route_comp", "rediect_url"].includes(item_type) && (
        <Tooltip
          title={label}
          enterDelay={400}
          leaveDelay={100}
          disableHoverListener={extentedSidebar}
          placement="right"
        >
          <div className="list-item-content">
            {routeObj.icon ? routeObj.icon : extentedSidebar ? "" : label.slice(0, 3) + ".."}
            {Boolean(extentedSidebar) && label}
            {/* {true && label} */}
            {item_type === "rediect_url" && extentedSidebar && (
              <IconButton size="sm" className="sidebar-lititem-action-icon">
                <OpenInNewIcon />
              </IconButton>
            )}
          </div>
        </Tooltip>
      )}
    </li>
  );
};

function Sidebar() {
  const location = useLocation()
  const navigate = useNavigate();
  const system_list = getParsedLocalStorage("systems_list", []);
  const { loading, handleLogout } = useLogout();
  const sidebar_routes = useMemo(() => {
    let _routes = newSidebarRoutes;

    const telemetry_routes = _routes.find((route) => route.key === "TELEMETRY");
    telemetry_routes.childs = system_list.reduce((acc, val) => {
      if (val.code) {
        let sys_code = val.code?.split("/").join("*");
        let obj = {
          key: val.code,
          url: encodeURI(`telemetry/${sys_code}`),
          icon: null,
          type: "route_comp",
          label: val.alias,
          childs: null,
        };
        acc.push(obj);
        return acc;
      }
    }, []);

    const getAllowedRoutes = () => {
      const modulesAccessList = window.frontendAccess;

      _routes = _routes.filter((routObj) => {
        let isValid = true;
        const { type, childs, key } = routObj;
        const accessObject = modulesAccessList?.[key] ?? null;
        if (accessObject && accessObject?.readAll === false && accessObject?.readSelf === false) {
          isValid = false;
        }
        if (isValid && type === "collapse_list" && childs?.length > 0) {
          routObj.childs = routObj.childs.filter((childObj) => {
            const childAccessobj = modulesAccessList?.[`${key}-${childObj.key}`] ?? null;
            if (childAccessobj && childAccessobj?.readAll === false && childAccessobj?.readSelf === false) {
              return false;
            }
            return true;
          });
        }
        return isValid;
      });
      return _routes;
    };
    //{ key: "FAILURE_BY_CATEGORY", url: "reports/failures-by-category", icon: null, type: "route_comp", label: "Failures by Category", childs: null },
    return getAllowedRoutes();
  }, []);
  const dispatch = useDispatch();
  const extentedSidebar = useSelector(selectedExtentedSidebar);
  const toggleSidbar = () => {
    dispatch(updateExtentedSidebar(!extentedSidebar));
  };

  const onListitemClick = (routeObj, route_key) => {
    const { type, url, passCreds, key } = routeObj;
    if (type === "route_comp") {

      dispatch(updateSelectedSidebarKey(route_key));
      navigate(url);
    }
    if (type === "rediect_url") {
      console.log("routeObj", routeObj);
      if (key === "FAMS_RE") {
        const res = redirectToFams();
        console.log("res", res);  
        if (!res.success) {
          toast.error(res.err.message);
          toast.error("Re-Login required. Logging Out in 1 Second");
          setTimeout(() => {
            handleLogout(getLocalStorage("userId"), false);
          }, 1000);
        }
      } else {
        window.open(url, "_blank");
      }
    }
  };
  useEffect(() => {
const _url = location.pathname;
const url_nav_key = getRoutObjByUrl(_url);

if(url_nav_key){
    dispatch(updateSelectedSidebarKey(url_nav_key));
}

    return () => {
      //   dispatch(resetSidebar());
    };
  }, [location]);

  return (
    <div id="sidebar" className={`${extentedSidebar ? "sidebar-extended" : "sidebar-not-extended"} prevent-select `}>
      <div className="sidebar-header">
        <div className="logos">
          <img className="pointer" src={tams_logo} alt="Bitcomm Logo" height="45px" />
          {extentedSidebar && (
            <>
              <div className="divider"></div>
              <img className="pointer" src={bt_logo} alt="Bitcomm Logo" height="40px" />
            </>
          )}
        </div>
      </div>
      <ul spacing={1} id="sidebar-route-list">
        {sidebar_routes.map((routeObj) => {
          return <SidebarListItem key={routeObj.key} routeObj={routeObj} onListitemClick={onListitemClick} />;
        })}
      </ul>
      <div id="sidebar-footer">
        <IconButton onClick={toggleSidbar}>{extentedSidebar ? <ArrowBackIcon /> : <ArrowForwardIcon />}</IconButton>
        {/* <Button onClick={toggleSidbar}>{extentedSidebar ? "Collapse" : "Extend"}</Button> */}
      </div>
      <p className="textAlignCenter" style={{color: "#637381" }}>v{packageJson.version}</p>
    </div>
  );
}

export default Sidebar;
